import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RolService } from '../shared/rol.service';
import { NotificationService, LoaderService, EVENTO, TOOLTIPS, ICONS, ACTIONS } from "../../../../shared/session/index";
import { Rol } from "../shared/rol.model";
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';

@Component({
  selector: 'app-rol-edit',
  templateUrl: 'rol-edit.component.html'
})
export class RolEditComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGrupEditRol: FormGroup;
  msgErrorActualizar: string;
  msgErrorGet: string;
  obligatorioMsg: string;
  rol: Rol;
  maxLengthMsg: string;
  nomRolMaxLength: number;
  descripcionMaxLength: number;
  nomRolPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_NUMERO_MSG;
  buttonGroup: any;

  constructor(
    private loaderService: LoaderService,
    private rolService: RolService,
    private notificationService: NotificationService,
    public fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.rol = new Rol();
    this.msgErrorActualizar = 'Error al actualizar datos';
    this.msgErrorGet = 'Error al obtener datos';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño máximo es de ';
    this.nomRolMaxLength = 100;
    this.descripcionMaxLength = 250;
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.setValuesFormBuilder();
    this.obtenerRol(this.data.rol.ID);
  }

  setValuesFormBuilder() {
    this.formGrupEditRol = this.fb.group({
      Name: [this.rol.Name, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomRolMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      shortName: [this.rol.shortName, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomRolMaxLength),
      ])],
      description: [this.rol.Description, Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      status: [this.rol.Status],
    });
  }

  changeEvent(rol: Rol) {
    this.data.rol = rol;
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  formGrupEditRolSubmit(event) {
    if (this.formGrupEditRol.invalid)
      return;
    this.rol.Name = event.value.Name
    this.rol.shortName = event.value.shortName;
    this.rol.Description = event.value.description;
    this.rol.Status = event.value.status
    this.actualizarRol(this.rol);
  }

  actualizarRol(rol: Rol) {
    this.loaderService.show();
    this.rolService.actualizarRol(rol)
      .subscribe(res => {
        this.changeEvent(rol);
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          this.notificationService.error(this.msgErrorActualizar);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  obtenerRol(rolID: number): void {
    this.loaderService.show();
    this.rolService.obtenerRol(rolID)
      .subscribe(res => {
        this.rol = res;
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.setValuesFormBuilder();
          this.loaderService.hide();
        });
  }
}
